export type BaseAudio = {
  base64: string;
  startTime: string;
  duration: number;
  description?: string;
  categoryUuid?: string;
};

export type VoiceOver = BaseAudio;

export type Dubbing = BaseAudio;

export type AudioDescription = BaseAudio;

export function sumDurationToTime(timeString: string, durationMs: number) {
  // Parse time string into hours, minutes, and seconds
  const [hoursStr, minutesStr, secondsStr] = timeString.split(":");
  const hours = parseInt(hoursStr, 10);
  const minutes = parseInt(minutesStr, 10);
  const seconds = parseInt(secondsStr, 10);

  // Convert time components to milliseconds
  const totalTimeMs =
    hours * 3600000 + // 1 hour = 3600000 milliseconds
    minutes * 60000 + // 1 minute = 60000 milliseconds
    seconds * 1000; // 1 second = 1000 milliseconds

  // Add duration to total time
  const newTotalTimeMs = totalTimeMs + durationMs;

  // Convert total milliseconds back to hh:mm:ss format
  const newHours = Math.floor(newTotalTimeMs / 3600000);
  const newMinutes = Math.floor((newTotalTimeMs % 3600000) / 60000);
  const newSeconds = Math.floor((newTotalTimeMs % 60000) / 1000);

  // Format new time
  const newTimeString =
    `${newHours.toString().padStart(2, "0")}:` +
    `${newMinutes.toString().padStart(2, "0")}:` +
    `${newSeconds.toString().padStart(2, "0")}`;

  return newTimeString;
}
